module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"weight":{"placeholder":"Min = 0.1 kg | Maks = 60 kg"},"set_product_weight":"Set berat produk","you_made_count_changes":"Jumlah perubahan {count}","this_weight_will_applied":"Berat ini akan diterapkan ke semua produk di halaman ini"}}')
  delete Component.options._Ctor
}
